import React from 'react';
import {Box} from '@chakra-ui/core';

const Table = ({children, ...props}) => {
	return (
		<Box as="table" width="100%" {...props}>
			<tbody>{children}</tbody>
		</Box>
	);
};

export default Table;
